(function () {
  'use strict';

  function initHeaderSearch() {
    var root = document.querySelector('[data-header-search]');
    if (!root) return;

    var toggle = root.querySelector('[data-header-search-toggle]');
    var panel = root.querySelector('[data-header-search-panel]');
    if (!toggle || !panel) return;

    function isOpen() {
      return root.classList.contains('is-open');
    }

    function openSearch() {
      root.classList.add('is-open');
      panel.removeAttribute('hidden');
      panel.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Close search');
      var input = panel.querySelector('input[type="search"]');
      if (input) {
        window.setTimeout(function () {
          input.focus();
        }, 120);
      }
    }

    function closeSearch() {
      root.classList.remove('is-open');
      panel.setAttribute('hidden', '');
      panel.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Open search');
    }

    toggle.addEventListener('click', function (e) {
      e.stopPropagation();
      if (isOpen()) {
        closeSearch();
      } else {
        openSearch();
      }
    });

    panel.addEventListener('click', function (e) {
      e.stopPropagation();
    });

    document.addEventListener('click', function (e) {
      if (isOpen() && !root.contains(e.target)) {
        closeSearch();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen()) {
        closeSearch();
        toggle.focus();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderSearch);
  } else {
    initHeaderSearch();
  }
})();